import { createAction, props } from '@ngrx/store';
import { IBeneficiaries, ICharityBeneficiaryRequest, IIndividualBeneficiaryRequest, ITrustBeneficiaryRequest } from '../models/beneficiaries.model';
import { IBeneficiaryDetail } from '../models/beneficiaries.model';

export const loadBeneficiaries = createAction('[Beneficiaries] Load Beneficiaries', props<{ request: { employeeId: string } }>());

export const loadBeneficiariesSuccess = createAction('[Beneficiaries] Load Beneficiaries Success', props<{ response: IBeneficiaries[] }>());

export const loadBeneficiariesFailure = createAction('[Beneficiaries] Load Beneficiaries Failure', props<{ error: Error | any }>());

export const loadBeneficiary = createAction('[Beneficiaries] Load Beneficiary', props<{ customerId: string, beneficiaryId: string }>());
export const loadBeneficiarySuccess = createAction('[Beneficiaries] Load Beneficiary Success', props<{ response: IBeneficiaryDetail }>());
export const loadBeneficiaryFailure = createAction('[Beneficiaries] Load Beneficiary Failure', props<{ error: Error | any }>());

export const addCharityBeneficiary = createAction('[Beneficiaries] Add Charity Beneficiary', props<{ customerId: string, request: ICharityBeneficiaryRequest }>());
export const addCharityBeneficiarySuccess = createAction('[Beneficiaries] Add Charity Beneficiary Success', props<{ response: string }>());
export const addCharityBeneficiaryFailure = createAction('[Beneficiaries] Add Charity Beneficiary Failure', props<{ error: any }>());

export const addIndividualBeneficiary = createAction('[Beneficiaries] Add Individual Beneficiary', props<{ customerId: string, request: IIndividualBeneficiaryRequest }>());
export const addIndividualBeneficiarySuccess = createAction('[Beneficiaries] Add Individual Beneficiary Success', props<{ response: string }>());
export const addIndividualBeneficiaryFailure = createAction('[Beneficiaries] Add Individual Beneficiary Failure', props<{ error: any }>());

export const addTrustBeneficiary = createAction('[Beneficiaries] Add Trust Beneficiary', props<{ customerId: string, request: ITrustBeneficiaryRequest }>());
export const addTrustBeneficiarySuccess = createAction('[Beneficiaries] Add Trust Beneficiary Success', props<{ response: string }>());
export const addTrustBeneficiaryFailure = createAction('[Beneficiaries] Add Trust Beneficiary Failure', props<{ error: any }>());

// Charity Delete
export const deleteCharityBeneficiary = createAction(
  '[Beneficiaries] Delete Charity Beneficiary',
  props<{ customerId: string, charityId: string }>()
);
export const deleteCharityBeneficiarySuccess = createAction(
  '[Beneficiaries] Delete Charity Beneficiary Success',
  props<{ response: any }>()
);
export const deleteCharityBeneficiaryFailure = createAction(
  '[Beneficiaries] Delete Charity Beneficiary Failure',
  props<{ error: any }>()
);
// Individual Delete
export const deleteIndividualBeneficiary = createAction(
  '[Beneficiaries] Delete Individual Beneficiary',
  props<{ customerId: string, beneficiaryId: string }>()
);
export const deleteIndividualBeneficiarySuccess = createAction(
  '[Beneficiaries] Delete Individual Beneficiary Success',
  props<{ response: any }>()
);
export const deleteIndividualBeneficiaryFailure = createAction(
  '[Beneficiaries] Delete Individual Beneficiary Failure',
  props<{ error: any }>()
);
// Trust Delete
export const deleteTrustBeneficiary = createAction(
  '[Beneficiaries] Delete Trust Beneficiary',
  props<{ customerId: string, trustId: string }>()
);
export const deleteTrustBeneficiarySuccess = createAction(
  '[Beneficiaries] Delete Trust Beneficiary Success',
  props<{ response: any }>()
);
export const deleteTrustBeneficiaryFailure = createAction(
  '[Beneficiaries] Delete Trust Beneficiary Failure',
  props<{ error: any }>()
);

// Charity Edit
export const editCharityBeneficiary = createAction(
  '[Beneficiaries] Edit Charity Beneficiary',
  props<{ customerId: string, charityId: string, request: ICharityBeneficiaryRequest }>()
);
export const editCharityBeneficiarySuccess = createAction(
  '[Beneficiaries] Edit Charity Beneficiary Success',
  props<{ response: any }>()
);
export const editCharityBeneficiaryFailure = createAction(
  '[Beneficiaries] Edit Charity Beneficiary Failure',
  props<{ error: any }>()
);
// Individual Edit
export const editIndividualBeneficiary = createAction(
  '[Beneficiaries] Edit Individual Beneficiary',
  props<{ customerId: string, beneficiaryId: string, request: IIndividualBeneficiaryRequest }>()
);
export const editIndividualBeneficiarySuccess = createAction(
  '[Beneficiaries] Edit Individual Beneficiary Success',
  props<{ response: any }>()
);
export const editIndividualBeneficiaryFailure = createAction(
  '[Beneficiaries] Edit Individual Beneficiary Failure',
  props<{ error: any }>()
);
// Trust Edit
export const editTrustBeneficiary = createAction(
  '[Beneficiaries] Edit Trust Beneficiary',
  props<{ customerId: string, trustId: string, request: ITrustBeneficiaryRequest }>()
);
export const editTrustBeneficiarySuccess = createAction(
  '[Beneficiaries] Edit Trust Beneficiary Success',
  props<{ response: any }>()
);
export const editTrustBeneficiaryFailure = createAction(
  '[Beneficiaries] Edit Trust Beneficiary Failure',
  props<{ error: any }>()
);
